import { defineAsyncComponent } from 'vue'
export default {
  ai: defineAsyncComponent(() => import("/app/app/layouts/ai.vue").then(m => m.default || m)),
  "auth-new": defineAsyncComponent(() => import("/app/app/layouts/auth-new.vue").then(m => m.default || m)),
  "main-screen-deprecated": defineAsyncComponent(() => import("/app/app/layouts/main-screen.deprecated.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/app/app/layouts/main.vue").then(m => m.default || m)),
  maintenance: defineAsyncComponent(() => import("/app/app/layouts/maintenance.vue").then(m => m.default || m))
}